(() => {
  const storageKey = 'cacb-confidence-set-last';

  const hashString = (value) => {
    let hash = 0;
    for (let index = 0; index < value.length; index += 1) {
      hash = ((hash << 5) - hash + value.charCodeAt(index)) | 0;
    }
    return Math.abs(hash);
  };

  const selectProductConfidence = (trust) => {
    if (!trust || trust.dataset.cacbConfidenceApplied === 'true') return;

    const source = trust.querySelector('[data-cacb-confidence-sets]');
    const quote = trust.querySelector('[data-cacb-confidence-quote]');
    const attribution = trust.querySelector('[data-cacb-confidence-attribution]');
    const gallery = trust.querySelector('.cacb-trust__mini-gallery');
    if (!source || !quote || !attribution || !gallery) return;

    let sets;
    try {
      sets = JSON.parse(source.textContent);
    } catch (error) {
      return;
    }
    if (!Array.isArray(sets) || sets.length === 0) return;

    let selectedIndex = hashString(window.location.pathname) % sets.length;
    try {
      const previousIndex = Number.parseInt(window.sessionStorage.getItem(storageKey), 10);
      if (sets.length > 1 && Number.isInteger(previousIndex) && previousIndex >= 0 && previousIndex < sets.length) {
        selectedIndex = (previousIndex + 1) % sets.length;
      }
      window.sessionStorage.setItem(storageKey, String(selectedIndex));
    } catch (error) {
      // Storage can be unavailable in privacy modes; the product-path hash remains a stable fallback.
    }

    const selectedSet = sets[selectedIndex];
    if (!selectedSet || !selectedSet.quote || !selectedSet.attribution || !Array.isArray(selectedSet.images)) return;

    quote.textContent = `“${selectedSet.quote}”`;
    attribution.textContent = selectedSet.attribution;
    gallery.replaceChildren(...selectedSet.images.map((image) => {
      const link = document.createElement('a');
      link.href = '/pages/our-customer-reviews';
      link.setAttribute('aria-label', `Open ${image.label}'s review in the customer review gallery`);

      const photo = document.createElement('img');
      photo.src = image.src;
      photo.alt = image.alt;
      photo.loading = 'lazy';
      photo.width = 500;
      photo.height = 500;

      const label = document.createElement('span');
      label.textContent = image.label;
      link.append(photo, label);
      return link;
    }));
    trust.dataset.cacbConfidenceSet = String(selectedIndex);
    trust.dataset.cacbConfidenceApplied = 'true';
  };

  const arrangeProductConfidence = () => {
    if (!document.body?.classList.contains('template-product')) return false;

    const productForm = document.querySelector('product-form.js-product.product-info');
    const productColumn = productForm?.querySelector('.product-column-right');
    const keepBrowsing = productColumn?.querySelector('.cacb-keep-browsing');
    const trust = document.querySelector('.cacb-trust--product');
    const trustSection = trust?.closest('.shopify-section');

    selectProductConfidence(trust);

    if (!productColumn || !keepBrowsing || !trustSection) return false;

    // Keep Browsing is nested inside .product-form, not a direct child of the column.
    const layoutParent = keepBrowsing.parentElement;
    if (!layoutParent || trustSection.contains(layoutParent)) return false;
    if (trustSection.parentElement !== layoutParent || trustSection.nextElementSibling !== keepBrowsing) {
      layoutParent.insertBefore(trustSection, keepBrowsing);
    }

    // Vintage Materials Notice is rendered inside the decision-confidence aside
    // by Liquid so variant/section replacements preserve its complete contents.

    productColumn.classList.add('cacb-confidence-layout-ready');
    return true;
  };

  if (!arrangeProductConfidence()) {
    document.addEventListener('DOMContentLoaded', arrangeProductConfidence, { once: true });
  }
  document.addEventListener('shopify:section:load', arrangeProductConfidence);
})();


